import { render, staticRenderFns } from "./ListDiscounts.vue?vue&type=template&id=3da31d3e&"
import script from "./ListDiscounts.vue?vue&type=script&lang=ts&"
export * from "./ListDiscounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports